export const shouldEnableTimer = user => {
  const email = user?.email
  if (email?.includes('@cfctest.org') || email?.includes('@example.com'))
    return true
}
